module.exports = __webpack_public_path__ + "static/media/new.937609f8.png";